/**
 * Gets email from account info.
 * @param account Account info to get email from.
 */
export var getEmailFromAccount = function (account) {
    var _a;
    var idTokenClaims = account.idTokenClaims;
    return ((_a = idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.email) === null || _a === void 0 ? void 0 : _a.trim()) || '';
};
